import { menuTree, type MenuCode, type MenuTreeNode } from "@pmc350/shared";

export interface MenuItem {
  path: string;
  label: string;
  mark?: string;
  menuKey: MenuCode;
}

export const primaryMenuItems: MenuItem[] = [
  { path: "/dashboard", label: "运行总览", mark: "◫", menuKey: "dashboard" },
  { path: "/devices", label: "设备管理", mark: "▧", menuKey: "devices" },
  { path: "/alarms", label: "告警中心", mark: "△", menuKey: "alarms" },
  { path: "/personnel", label: "人员管理", mark: "◎", menuKey: "personnel" },
  { path: "/audit", label: "审计日志", mark: "≡", menuKey: "audit" },
  { path: "/exports", label: "导出任务", mark: "⇩", menuKey: "exports" },
];

export const settingsMenuItems: MenuItem[] = [
  { path: "/settings", label: "参数配置", menuKey: "settings" },
  { path: "/mqtt-gateway", label: "MQTT 网关", menuKey: "mqtt_gateway" },
  { path: "/modbus-gateway", label: "Modbus 网关", menuKey: "modbus_gateway" },
  { path: "/raw-protocol", label: "原始协议", menuKey: "raw_protocol" },
];

export const permissionMenuTree: MenuTreeNode[] = menuTree;

export function menuNameMap(nodes: MenuTreeNode[] = permissionMenuTree): Record<MenuCode, string> {
  return Object.fromEntries(nodes.flatMap((node) => [
    [node.key, node.label],
    ...(node.children ?? []).map((child) => [child.key, child.label]),
  ])) as Record<MenuCode, string>;
}
